<header>
  <img src="assets/logo.svg" alt="Logo Pokedex">
</header>
